import { Button, TableItem } from 'components/atoms';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useCustomParamId } from 'hooks/useParamId';
import { usePermissionGuard } from 'hooks/usePermissionGuard';
import { useStreamFileDownload } from 'hooks/useStreamFileDownload';
import { t } from 'i18next';
import { PiCaretLeftBold, PiDownload } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetHistoricalReportsByLabelInfinite,
  useGetLabelReportFile,
} from 'services/label-report';
import { formatCurrency } from 'utils/global/currency.utils';
import { getMaxFormattedLength } from 'utils/global/getMaxFormattedLength.utils';
import { getSettlementPeriodName } from 'utils/global/name.utils';

const LabelReportsHistory = () => {
  const labelId = useCustomParamId('id', '/label');

  usePermissionGuard('LabelReportOrderPermissionsLIST**');

  const navigate = useNavigate();

  const labelReports = useGetHistoricalReportsByLabelInfinite(labelId);

  const tableParams = useInfiniteTable(labelReports, { selectable: false });

  const { setFile } = useStreamFileDownload(useGetLabelReportFile);

  const allAmountLength = getMaxFormattedLength(
    tableParams.data?.nodes ?? [],
    e => e?.amountEarned
  );

  const allAmountLabelLength = getMaxFormattedLength(
    tableParams.data?.nodes ?? [],
    e => e?.amountForLabel
  );

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t('history.label-raports')}
          size='compact'
          customBackItem={
            <Button
              isClear
              onlyIcon
              onClick={() => navigate(`/label/${labelId}/reports`)}>
              <Button.Icon icon={<PiCaretLeftBold />} />
            </Button>
          }
        />
      }>
      <Table
        id={'LabelReports-history-file'}
        {...tableParams}
        size='compact'
        columns={[
          {
            label: t('input.label.startSettlementPeriod'),
            renderCell: ({ startSettlementPeriodName }) => (
              <TableItem>
                <TableItem.Text
                  text={getSettlementPeriodName(startSettlementPeriodName)}
                />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.endSettlementPeriod'),
            renderCell: ({ endSettlementPeriodName }) => (
              <TableItem>
                <TableItem.Text
                  text={getSettlementPeriodName(endSettlementPeriodName)}
                />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.number'),
            renderCell: ({ labelReportNumber }) => (
              <TableItem>
                <TableItem.Text text={labelReportNumber ?? undefined} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.amountEarned'),
            renderCell: ({ amountEarned }) => (
              <TableItem>
                <TableItem.Currency
                  text={formatCurrency(amountEarned, {
                    length: allAmountLength,
                  })}
                />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.amountForLabel'),
            renderCell: ({ amountForLabel }) => (
              <TableItem>
                <TableItem.Currency
                  text={formatCurrency(amountForLabel, {
                    length: allAmountLabelLength,
                  })}
                />
              </TableItem>
            ),
          },
          {
            label: '',
            renderCell: ({ id, filePath, labelReportNumber }) => (
              <TableItem justifyPosition='end'>
                <div className='flex gap-1'>
                  {/* <a
                                  href={filePath ?? ''}
                                  download={filePath}
                                  aria-disabled={!filePath}
                                  target='_blank'
                                  rel='noreferrer'> */}
                  <Button
                    type='button'
                    isClear
                    onlyIcon
                    onClick={() =>
                      setFile({
                        id,
                        name: labelReportNumber ?? filePath ?? '',
                      })
                    }
                    disabled={!filePath}>
                    <Button.Icon icon={<PiDownload />} />
                  </Button>
                  {/* </a> */}
                </div>
              </TableItem>
            ),
          },
        ]}
      />
    </TopbarPage>
  );
};

export default LabelReportsHistory;
